import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Card, Chip, Input, baht, fmtCoins } from "../ui";
import PaymentQrModal from "./PaymentQrModal";
import { creditCalc } from "../../services/fb/pricing";
import { useToast } from "../../context/ToastContext";
import api from "../../services/api";

/** แท็บ "แพ็กสร้างตัวละคร" : ซื้อสิทธิ์สร้างตัวละคร (ตัวละ N บาท ลดตามจำนวน) ด้วย QR — ราคา/ขั้นส่วนลดมาจาก settings ใน DB */
export default function CreditPacks({ cfg, credits, onDone, onClose }) {
  const toast = useToast();
  const [sel, setSel] = useState(cfg.presets.length > 1 ? cfg.presets[1].qty : 1); // number | "custom"
  const [custom, setCustom] = useState("");
  const [payFor, setPayFor] = useState(null);

  const customCalc = custom === "" ? null : creditCalc(Number(custom), cfg);
  const cur = sel === "custom" ? (customCalc && customCalc.ok ? customCalc : null) : cfg.presets.find((p) => p.qty === sel) || null;
  const pkg = cur ? { id: "create_credit", kind: "credit", name: `สิทธิ์สร้างตัวละคร ${cur.qty} ตัว`, qty: cur.qty, price: cur.price } : null;

  const onConfirm = async (qr) => {
    const r = await api.credits.confirm(qr.transactionId);
    toast("ซื้อสิทธิ์สร้างตัวละครสำเร็จ", "success");
    onDone(r);
    return r;
  };

  return (
    <div>
      <Card className="row coins-balance mb-16" aria-label={`สิทธิ์สร้างตัวละครคงเหลือ ${credits}`}><span className="muted">สิทธิ์สร้างตัวละครคงเหลือ</span><b>{fmtCoins(credits)}</b></Card>
      <p className="muted" style={{ fontSize: 13 }}>สร้างและบันทึกร่างได้ฟรี · ใช้ 1 สิทธิ์ตอนเผยแพร่ตัวละครครั้งแรก (แก้ไขหลังเผยแพร่ไม่หักซ้ำ) · ราคาตัวละ {baht(cfg.price)} ยิ่งซื้อมากยิ่งลดมาก</p>
      <div className="pkg-grid mt-16" role="radiogroup" aria-label="เลือกแพ็กสิทธิ์สร้างตัวละคร">
        {cfg.presets.map((p) => (
          <button key={p.qty} role="radio" aria-checked={sel === p.qty} className={`pkg pkg--card${sel === p.qty ? " is-active" : ""}`} onClick={() => setSel(p.qty)}>
            <span className="pkg__emoji" aria-hidden="true">🎭</span>
            <span className="grow">
              <span className="strong">{fmtCoins(p.qty)} ตัวละคร</span>
              {p.discountPercent ? <Chip size="sm" className="is-active" style={{ marginLeft: 6 }}>ลด {p.discountPercent}%</Chip> : null}
              <span className="muted pkg__meta">{p.discountPercent ? <>ตัวละ {baht(Math.round(p.price / p.qty))} · ประหยัด <b className="pkg__bonus">{baht(p.saved)}</b></> : `ตัวละ ${baht(p.unit)}`}</span>
            </span>
            <span className="pkg__price"><span className="strong">{baht(p.price)}</span></span>
          </button>
        ))}
        <div role="radio" aria-checked={sel === "custom"} tabIndex={-1} className={`pkg pkg--card${sel === "custom" ? " is-active" : ""}`} onClick={() => setSel("custom")} style={{ alignItems: "flex-start" }}>
          <span className="pkg__emoji" aria-hidden="true">✏️</span>
          <span className="grow">
            <span className="strong">กำหนดเอง</span>
            <Input aria-label="จำนวนตัวละครที่ต้องการซื้อ" type="number" inputMode="numeric" min={1} max={cfg.max} step={1} placeholder={`1–${cfg.max} ตัว`} value={custom}
              onFocus={() => setSel("custom")} onChange={(e) => { setSel("custom"); setCustom(e.target.value); }}
              error={sel === "custom" && customCalc && !customCalc.ok ? customCalc.reason : undefined} style={{ marginBottom: 0 }} />
            {sel === "custom" && customCalc && customCalc.ok ? (
              <span className="muted pkg__meta">{customCalc.discountPercent ? <>ลด <b className="pkg__bonus">{customCalc.discountPercent}%</b> · ประหยัด {baht(customCalc.saved)}</> : "ยังไม่ถึงขั้นส่วนลด"}</span>
            ) : null}
          </span>
          <span className="pkg__price"><span className="strong">{sel === "custom" && customCalc && customCalc.ok ? baht(customCalc.price) : "—"}</span></span>
        </div>
      </div>
      <div className="pay-bar">
        <div className="grow muted" style={{ fontSize: 13 }}>{cur ? <>ได้รับ <b>{fmtCoins(cur.qty)}</b> สิทธิ์สร้างตัวละคร{cur.discountPercent ? ` · ลด ${cur.discountPercent}%` : ""}</> : "เลือกแพ็กหรือกรอกจำนวนตัวละคร"}</div>
        <Button variant="primary" size="lg" disabled={!pkg} onClick={() => setPayFor(pkg)}>{pkg ? `ชำระเงิน ${baht(pkg.price)}` : "เลือกแพ็กเกจ"}</Button>
      </div>
      <p className="faint mt-8" style={{ fontSize: 12 }}>ชำระด้วย QR เดียวกับการเติมคอยน์ · สิทธิ์เข้าอัตโนมัติหลังชำระ · <Link to="/create">ไปสร้างตัวละคร</Link></p>
      <PaymentQrModal open={!!payFor} pkg={payFor} onClose={() => { setPayFor(null); onClose(); }} onConfirm={onConfirm} />
    </div>
  );
}
